import React from 'react';
import { Chip, ChipProps } from '@mui/material';

interface StatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: 'enabled' | 'disabled';
}

/**
 * A reusable component to display campaign status consistently across the application
 */
const StatusChip: React.FC<StatusChipProps> = ({ status, ...props }) => {
  return (
    <Chip
      label={status === 'enabled' ? 'Enabled' : 'Disabled'}
      size="small"
      color={status === 'enabled' ? 'success' : 'default'}
      sx={{ minWidth: '80px', ...props.sx }}
      {...props}
    />
  );
};

export default StatusChip;
